import { Controller } from "@hotwired/stimulus"

// Controller to handle conflict state refresh for plantafel task bars
// This controller is triggered by a turbo stream action when a task is updated
export default class extends Controller {
  static values = {
    taskId: Number,
    hasConflicts: Boolean,
  }

  connect() {
    // Apply the conflict styling immediately on connect
    this.applyConflictStyling()

    // Remove the element after applying styling (it's just a trigger)
    this.element.remove()
  }

  applyConflictStyling() {
    const taskId = this.taskIdValue
    const hasConflicts = this.hasConflictsValue

    // Find all task bar containers for this task
    const taskContainers = document.querySelectorAll(`[data-task-id="${taskId}"].relative.h-10`)

    if (taskContainers.length === 0) {
      return
    }

    taskContainers.forEach((container) => {
      const taskBar = container.querySelector('[data-controller*="plantafel-element"]')

      if (taskBar) {
        if (hasConflicts) {
          // Apply conflict styling
          taskBar.style.background =
            "repeating-linear-gradient(-45deg, transparent, transparent 8px, rgba(232, 79, 79, 0.15) 8px, rgba(232, 79, 79, 0.15) 9px), #D9EFE9"
          taskBar.style.border = "1px solid #E84F4F"

          // Update the color indicator dot
          const dot = taskBar.querySelector(".rounded-full.mr-1\\.5")
          if (dot) {
            dot.style.backgroundColor = "#E84F4F"
          }
        } else {
          // Remove conflict styling
          taskBar.style.background = "#D9EFE9"
          taskBar.style.border = ""

          // Reset the color indicator dot
          const dot = taskBar.querySelector(".rounded-full.mr-1\\.5")
          if (dot) {
            dot.style.backgroundColor = "#009C72"
          }
        }
      }

      // Update tooltip controller presence
      if (hasConflicts && !container.hasAttribute("data-controller")) {
        container.setAttribute("data-controller", "plantafel-tooltip")
      } else if (
        !hasConflicts &&
        container.getAttribute("data-controller") === "plantafel-tooltip"
      ) {
        container.removeAttribute("data-controller")
      }
    })
  }
}
